import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UsuarioService } from './api-usuario.service';

@Injectable({
  providedIn: 'root',
})
export class UsuarioDataService {
  constructor(private api: UsuarioService) {}

  CarregaDataUltimoFechamentoExecutivo(): Observable<any> {
    return this.api.CarregaDataUltimoFechamentoExecutivo();
  }
}
